import { INavData } from '@coreui/angular';

export const navItems: INavData[] = [
  {
    name: 'Dashboard',
    url: '/dashboard',
    iconComponent: { name: 'cilList' },
  },
  {
    name: 'Tellers',
    url: '/teller',
    iconComponent: { name: 'cilUser' },
  },
  {
    name: 'Draw',
    url: '/draw',
    iconComponent: { name: 'cilMediaPlay' },
  },
  {
    name: 'Hot Numbers',
    url: '/hotnumbers',
    iconComponent: { name: 'cilStar' },
  },
  {
    name: 'Key Code',
    url: '/keycode',
    iconComponent: { name: 'cilStar' },
  },
  {
    name: 'Group',
    url: '/operator',
    iconComponent: { name: 'cilFile' },
  },
  {
    name: 'Reports',
    url: '/report',
    iconComponent: { name: 'cilNotes' },
    children: [
      {
        name: 'Running Bet Amount',
        url: '/runningbet',
      },
      {
        name: 'Gross Report',
        url: '/grossreport',
      },
      {
        name: 'Winning Bets',
        url: '/winningbets',
      },
    ],
  },
  //
  // {
  //   name: 'Pages',
  //   url: '/login',
  //   iconComponent: { name: 'cil-star' },
  //   children: [
  //     {
  //       name: 'Login',
  //       url: '/login',
  //     },
  //     {
  //       name: 'Register',
  //       url: '/register',
  //     },
  //     {
  //       name: 'Error 404',
  //       url: '/404',
  //     },
  //     {
  //       name: 'Error 500',
  //       url: '/500',
  //     },
  //   ],
  // },
];
